module.exports = __webpack_public_path__ + "img/profile.6f23bd87.svg";